<header class="header">
  <img src="assets/images/logo_dfs_venue.png" alt="Venue" class="header_logo">
  <hr />
</header>
